<template>
  <header id="site-header" class="site-header" :class="{ 'open' : isOpen }">
    <div class="wrap flex">
      <a href="/home" class="logo">
        <img src="/images/logo-reversed.svg" alt="Pool Focus" />
      </a>

      <nav>
        <ul>
          <li
            v-for="(link, index) of data"
            :key="index"
          >
            <a v-if="link !== null" :href="link.url">{{ link.title }}</a>
            <span class="icon icon-angle-down" v-if="link !== null && link.children"></span>
            <ul class="child" v-if="link !== null && link.children">
              <li
                v-for="(child, index) of link.children"
                :key="index"
              >
                <a :href="child.url">{{ child.title }}</a>
              </li>
            </ul>
          </li>

          <li>
            <a href="/contact-us" class="button desktop">Contact Us</a>
            <a href="/contact-us" class="mobile">Contact Us</a>
          </li>
        </ul>
      </nav>

      <!-- <a href="tel:09-489 6263" class="tel-mob">09-489 6263</a> -->

      <button class="hamburger mobile" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  props: [
    'csrf','data', 'logged_in'
  ],  
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    
    toggleMenu() {
      this.isOpen = !this.isOpen;
    }

  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue